export class PaginationRange {
    PaginationRangeId: string;
    PaginationRangeVal: string;
}
